const firstSubmenuLayers = document.querySelectorAll('#navbarSupportedContent .nav-item:not(.alt-layout):not(.ume-ch-facility-info-parent-menu-item) .first-submenu-layer');

if (firstSubmenuLayers) {
    for (let layer of firstSubmenuLayers) {
        const linksWithImages = layer.querySelectorAll('.has-image');
        const row = layer.querySelector('.row');
        const textMenuItems = layer.querySelectorAll('.dropdown-item');

        let numberOfImgColumns = 0;


        if (linksWithImages) {
            numberOfImgColumns = neededImgColumns(linksWithImages.length);

            let columnsArr = generateImgColumns(numberOfImgColumns);

            if (row) {
                // iterate images
                for (let i = 0; i < linksWithImages.length; i++) {
                    try {
                        if (i > numberOfImgColumns - 1) {
                            // remove img nodes when the maximum amount has already been inserted
                            linksWithImages[i].remove();
                        }
                        else{
                            columnsArr[i].appendChild(linksWithImages[i]);

                            // append to DOM
                            row.appendChild(columnsArr[i]);
                        }
                    } catch (e) {
                        console.error(e.message);
                    }
                }
            }
        }

        // insert text items
        if(textMenuItems){
            let textDiv = document.createElement('div');
            textDiv.classList.add('col', 'menu-text-item-wrapper', 'col-12');


            let textColumnSize = numberOfImgColumns !== 0 ? 12-numberOfImgColumns * 3 : 12;

            textDiv.classList.add('col-xl-' + textColumnSize);


            for(let item of textMenuItems){
                textDiv.appendChild(item);
            }

            if(row){
                row.appendChild(textDiv);
            }
        }
    }
}


function generateImgColumns(numberOfColumns) {
    let columnsArr = [];

    for (let i = 1; i <= numberOfColumns; i++) {
        let div = document.createElement('div');
        div.classList.add('col', 'd-none', 'd-xl-block', 'col-xl-3');
        div.classList.add('menu-image-wrapper');

        columnsArr.push(div);
    }

    return columnsArr;
}


function neededImgColumns(numberOfImages) {
    // calculate numberOfNeededColumns
    if (numberOfImages) {
        if (numberOfImages > 0) {
            return Math.min(3, numberOfImages);
        }
    }

    return 0;
}

// ----------------------- ALT LAYOUT ---------------------------- //


// the sub-sub-holders only exist for nav-items that actually have a 2nd layer dropdown menu.
// nav-items in the 1st dropdown layer with alt-layout but without 2nd layer dropdown menu should not be selected here.
const subSubHolders = document.querySelectorAll('#navbarSupportedContent .nav-item.alt-layout:not(.ume-ch-facility-info-parent-menu-item) .first-submenu-layer .ume-sub-sub-holder');

if(subSubHolders) {
    for (let subSubHolder of subSubHolders) {
        // inside every sub-sub-holder is the link "Klinik, Fachabteilungen", "Zentren" and as a sibling the 2nd layer dropdown menu
        // 2nd layer dropdown menu class is "dropdown-menu.dropdown-menu__side"

        // row needs to be appended as child for "dropdown-menu.dropdown-menu__side"

        const linksWithImages = subSubHolder.querySelectorAll('.has-image');
        const dropdownMenuSide = subSubHolder.querySelector('.dropdown-menu.dropdown-menu__side');
        // textMenuItems and those with images are inside dropdown-menu__side
        const textMenuItems = subSubHolder.querySelectorAll('.dropdown-menu.dropdown-menu__side .dropdown-item:not(.has-image)');

        let numberOfImgColumns = 0;

        let bsRow = document.createElement('div');
        bsRow.classList.add('row');
        dropdownMenuSide.appendChild(bsRow);

        if (linksWithImages) {
            numberOfImgColumns = neededImgColumns(linksWithImages.length);

            let columnsArr = generateImgColumns(numberOfImgColumns);

            if (dropdownMenuSide) {

                // iterate images
                for (let i = 0; i < linksWithImages.length; i++) {
                    try {
                        if (i > numberOfImgColumns - 1) {
                            // remove img nodes when the maximum amount has already been inserted
                            linksWithImages[i].remove();
                        }
                        else{
                            columnsArr[i].appendChild(linksWithImages[i]);

                            // append to DOM
                            bsRow.appendChild(columnsArr[i]);
                        }
                    } catch (e) {
                        console.error(e.message);
                    }
                }
            }
        }

        // insert text items
        if(textMenuItems){
            let textDiv = document.createElement('div');
            textDiv.classList.add('col', 'col-12', 'menu-text-item-wrapper');


            let textColumnSize = numberOfImgColumns !== 0 ? 12-numberOfImgColumns * 3 : 12;

            textDiv.classList.add('px-4');
            textDiv.classList.add('col-xl-' + textColumnSize);

            if(textColumnSize === 12 || textColumnSize === 9){
                let firstTextSubDiv = document.createElement('div');
                let secondTextSubDiv = document.createElement('div');


                for(let i= 0; i < textMenuItems.length; i++) {
                    if (i < (textMenuItems.length / 2)) {
                        firstTextSubDiv.appendChild(textMenuItems[i]);
                    } else {
                        secondTextSubDiv.appendChild(textMenuItems[i]);
                    }
                }

                textDiv.appendChild(firstTextSubDiv);
                textDiv.appendChild(secondTextSubDiv);
            }
            else{
                for(let item of textMenuItems){
                    textDiv.appendChild(item);
                }
            }


            if(dropdownMenuSide){
                bsRow.appendChild(textDiv);
            }
        }
    }
}